import getDateFormat from './getDateFormat'
import { format } from 'date-fns'
import { CustomDateObject } from '../shared/types'

const formatDate = (date?: CustomDateObject, selectedFormat?: string) => {
  const dateFormat = selectedFormat || getDateFormat('date')
  if (date && date.year && date.month && date.day) {
    return format(new Date(date.year, (date.month - 1), date.day), dateFormat)
  }
}

export default formatDate
